import { render, staticRenderFns } from "./JobDetailedImages.vue?vue&type=template&id=189844b3&scoped=true"
import script from "./JobDetailedImages.vue?vue&type=script&lang=ts"
export * from "./JobDetailedImages.vue?vue&type=script&lang=ts"
import style0 from "./JobDetailedImages.vue?vue&type=style&index=0&id=189844b3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189844b3",
  null
  
)

export default component.exports